import "./about.scss";
// import { Link } from "react-scroll";

function about() {
  return (
    <section className="main-container" id="about">
      <hr />
      <div className="container">
        <h2 className="heading">
          <span className="heading-main">About Me</span>
          <div className="heading-image">
            <div className="image-border">
              <div className="image">{/* <img src={Profile} /> */}</div>
            </div>
          </div>
          <span className="heading-sub">
            <p>
              I am a dynamic Full Stack Web Developer with a passion for
              crafting seamless, user-centric digital experiences. Proficient in
              both front-end and back-end technologies, I excel in creating
              responsive, scalable applications. My expertise includes{" "}
              <mark>
                HTML, CSS, JavaScript, PHP, React, Node.js, and databases like
                MySQL and MongoDB
              </mark>
              . I am committed to staying abreast of emerging technologies to
              ensure cutting-edge solutions.
            </p>
            &nbsp;
            <p>
              With a keen eye for detail and a problem-solving mindset, I thrive
              in collaborative environments, fostering innovation and delivering
              high-quality code. Dedicated to continuous learning, I embrace
              challenges, adapting swiftly to evolving industry trends. Let's
              build the future of the web together.
            </p>
          </span>
        </h2>
        <div className="contact-button">
          <a
            href="https://drive.google.com/file/d/1IngtuT6jc4hFiib0KKLIoJocN4IUBvPG/view?usp=sharing"
            target="_SM"
            className="btn"
            to="projects"
            smooth={true}
          >
            Download CV
          </a>
        </div>
      </div>
    </section>
  );
}

export default about;
